var $ = require('jQuery');
var router = require('pjax').Router;

router.get('setup-guide/:any', function () {
    $('a.done').click(function (e) {
        e.preventDefault();

        var icon = $(this).parents('.step').find('span[class~="af-icons-lg"]');
        var actions = $(this).parents('.step').find('.actions');

        $.post('/setup-guide/step/complete', { step: $(this).data('step') }, function () {
            icon.removeClass().addClass('af-icons-lg af-icons-lg-tick');
            actions.find('.incomplete').addClass('hidden');
            actions.find('.complete').removeClass('hidden');
        }, 'json');
    });

    var resetStep = function (link) {
        var icon = link.parents('.step').find('span[class~="af-icons-lg"]');
        var actions = link.parents('.step').find('.actions');

        icon.removeClass().addClass('af-icons-lg af-icons-lg-' + icon.data('guide-icon'));
        actions.find('.incomplete').removeClass('hidden');
        actions.find('.complete').addClass('hidden');
    };

    $('a.reset').click(function (e) {
        e.preventDefault();

        var link = $(this);
        $.post('/setup-guide/step/reset', { step: link.data('step') }, function () {
            resetStep(link);
        }, 'json');
    });

    $('button.reset-guide').click(function () {
        var section = $(this).data('section');
        $.post('/setup-guide/reset/'+section, function () {
            $('a.reset:visible').each(function () {
                resetStep($(this));
            });
        });
    });

    $('.action[href="#"]').attr('data-elevio-module', 'support').attr('id','support');
});
